import React, { memo } from "react";
import { SbBlokData } from "@storyblok/react";
import CustomStoryBlockComponent from "@/components/CustomStoryBlockComponent";

interface CommonFooterProps {
  blok: (SbBlokData & {})[];
}

function CommonFooter({ blok }: CommonFooterProps) {
  return (
    <ul>
      {blok.map((nestedBlok) => (
        <li className="li-spacing restrict-li" key={nestedBlok._uid}>
          <CustomStoryBlockComponent blok={nestedBlok} />
        </li>
      ))}
    </ul>
  );
}

export default memo(CommonFooter);
